export default "__VITE_ASSET__BFjjA5mB__"